import Alpine from 'alpinejs'
import "media-chrome"
import "vimeo-video-element"
import "youtube-video-element"
// import Swiper from 'swiper';
// import { Navigation, Pagination } from 'swiper/modules';
// import 'swiper/css';
import './main.css'

// ---------------------------------------------------------------------------------------------------- HOT MODULE REPLACEMENT (HMR)
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}

// // ---------------------------------------------------------------------------------------------------- SWIPER
// window.Swiper = Swiper
// Swiper.use([Navigation, Pagination]);

// ---------------------------------------------------------------------------------------------------- ALPINE
window.Alpine = Alpine
Alpine.start();
